import type { Surface } from '@/features/configurator/flow-plan';

/**
 * Где открыт код: блоком на сайте заказчика или мини-приложением
 * в телеграме.
 *
 * Задаётся при сборке, а не вычисляется по адресу или по наличию
 * `window.Telegram`: поверхность известна в момент, когда мы решаем,
 * что собираем, и угадывать её в рантайме значит получить приложение,
 * которое ведёт себя по-разному в зависимости от того, как его открыли.
 *
 * Значение читается один раз при загрузке модуля: смениться внутри
 * одного сеанса оно не может.
 */
export const SURFACE: Surface =
  (import.meta.env.VITE_SURFACE as Surface | undefined) === 'miniapp' ? 'miniapp' : 'site';
